import React from 'react';

const WhyUs = () => {
  return (
    <section className="bg-void py-24 relative overflow-hidden">
      <div className="container mx-auto px-6">
        
        {/* Header */}
        <div className="mb-16 text-center max-w-2xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-black text-white font-display mb-6">
                THE <span className="text-neon-blue">PERFORMANCE</span> STANDARD
            </h2>
            <p className="text-gray-400">
                Most agencies build websites. We build high-performance software assets.
            </p>
        </div>

        {/* The Dashboard Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            
            {/* Card 1: Speed Score (Visual: A Gauge/Circle) */}
            <div className="bg-surface border border-white/5 p-8 rounded-2xl relative overflow-hidden group hover:border-neon-blue/30 transition-all">
                <div className="absolute top-0 right-0 w-24 h-24 bg-neon-blue/10 blur-[50px] rounded-full" />
                
                <h3 className="text-gray-500 font-mono text-xs uppercase tracking-widest mb-4">Lighthouse Score</h3>
                <div className="flex items-end gap-2 mb-2">
                    <span className="text-6xl font-black text-white group-hover:text-neon-blue transition-colors">99</span>
                    <span className="text-xl text-gray-500 mb-2">/100</span>
                </div>
                <p className="text-sm text-gray-400">Google Core Web Vitals optimized for SEO ranking.</p>
                
                {/* Visual Bar */}
                <div className="w-full h-1 bg-gray-800 mt-6 rounded-full overflow-hidden">
                    <div className="w-[99%] h-full bg-neon-blue shadow-[0_0_10px_rgba(0,240,255,0.5)]"></div>
                </div>
            </div>

            {/* Card 2: Uptime/Reliability (Visual: Graph) */}
            <div className="bg-surface border border-white/5 p-8 rounded-2xl relative overflow-hidden group hover:border-purple-500/30 transition-all">
                <h3 className="text-gray-500 font-mono text-xs uppercase tracking-widest mb-4">System Stability</h3>
                <div className="text-5xl font-black text-white mb-4">99.9<span className="text-purple-500 text-3xl">%</span></div>
                <p className="text-sm text-gray-400">Crash-proof architecture using Node.js clustering.</p>
                
                {/* Visual Graph Line */}
                <div className="flex items-end gap-1 h-10 mt-4 opacity-50">
                    {[4,6,3,7,5,8,9,8,9,9].map((h,i) => (
                         <div key={i} className={`w-full bg-purple-500 rounded-t-sm`} style={{height: `${h*10}%`}}></div>
                    ))}
                </div>
            </div>

            {/* Card 3: Code Quality (Visual: Code Snippet) */}
            <div className="lg:col-span-2 bg-surface border border-white/5 p-8 rounded-2xl relative overflow-hidden group hover:border-green-500/30 transition-all">
                <div className="flex justify-between items-start mb-6">
                    <div>
                        <h3 className="text-gray-500 font-mono text-xs uppercase tracking-widest mb-2">Code Architecture</h3>
                        <p className="text-xl font-bold text-white">Clean, Scalable MERN Stack.</p>
                    </div>
                    {/* Badge */}
                    <div className="px-3 py-1 bg-green-500/10 border border-green-500/20 text-green-400 text-xs font-bold rounded uppercase">
                        Enterprise Grade
                    </div>
                </div>

                {/* Fake Code Block Visual */}
                <div className="bg-black/50 rounded-lg p-4 font-mono text-xs text-gray-400 leading-relaxed border-l-2 border-green-500">
                    <p><span className="text-purple-400">const</span> <span className="text-blue-400">App</span> = () =&gt; &#123;</p>
                    <p className="pl-4"><span className="text-gray-500">// Optimized for scale</span></p>
                    <p className="pl-4"><span className="text-purple-400">return</span> <span className="text-green-400">&lt;PerformanceLayer /&gt;</span>;</p>
                    <p>&#125;</p>
                </div>
            </div>

        </div>
      </div>
    </section>
  );
};

export default WhyUs;